export default __webpack_public_path__ + "static/media/devdurable.c63ba42c.jpeg";